const validate = ({
  spreadsheetId = '', sheetName = '', emailColumn = '',
}) => {
  const errors = {};

  if (!spreadsheetId) {
    errors.spreadsheetId = 'Debe ingresar un valor';
  }

  if (!sheetName) {
    errors.sheetName = 'Debe ingresar un nombre de hoja';
  }

  if (!emailColumn) {
    errors.emailColumn = 'Debe ingresar el nombre de la columna de email';
  }

  return errors;
};

export default validate;
